(function () {
  function formatMoney(cents, symbol) {
    var amount = (cents / 100).toFixed(2);
    if (symbol === '$') {
      return symbol + amount;
    }
    return amount + symbol;
  }

  function initMediaGallery(root) {
    if (!root || typeof Swiper === 'undefined') {
      return;
    }

    var mediaWrap = root.querySelector('[data-lp-hj-media]');
    var sectionId = root.getAttribute('data-lp-hj-buybox') || '';
    var mainEl = mediaWrap && mediaWrap.querySelector('.lp-hj-buybox__gallery-main' + sectionId);

    if (!mainEl || mainEl.dataset.hjGalleryReady === 'true') {
      return;
    }
    mainEl.dataset.hjGalleryReady = 'true';

    var thumbsEl = mediaWrap.querySelector('.lp-hj-buybox__gallery-thumbs' + sectionId);
    var thumbsSwiper = null;

    if (thumbsEl) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          990: {
            spaceBetween: 12
          }
        }
      });
    }

    new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 600,
      loop: false,
      observer: true,
      observeParents: true,
      
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
    });
  }

  function ensureSwiper(root, callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    var swiperSrc = root.getAttribute('data-swiper-src');
    if (!swiperSrc) {
      return;
    }

    var existingScript = document.querySelector('script[data-swiper-lp-hj-buybox]');

    if (existingScript) {
      existingScript.addEventListener('load', callback, { once: true });
      return;
    }

    var swiperScript = document.createElement('script');
    swiperScript.src = swiperSrc;
    swiperScript.dataset.swiperLpHjBuybox = 'true';
    swiperScript.onload = callback;
    document.head.appendChild(swiperScript);
  }

  function initHipJointBuybox(root) {
    if (!root || root.dataset.hjBuyboxReady === 'true') {
      return;
    }
    root.dataset.hjBuyboxReady = 'true';

    var configEl = root.querySelector('[data-lp-hj-buybox-config]');
    if (!configEl) {
      return;
    }

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('[lp-hj-buybox] Invalid config JSON', error);
      return;
    }

    var symbol = config.currencySymbol || '$';
    var size = config.defaultSize || 'small';
    var pType = 'sub';
    var qty = null;

    var tabs = root.querySelectorAll('[data-lp-hj-tab]');
    var panels = root.querySelectorAll('[data-lp-hj-panel]');
    var sizeBtns = root.querySelectorAll('[data-lp-hj-size]');
    var ptypeBtns = root.querySelectorAll('[data-lp-hj-ptype]');
    var tiles = root.querySelectorAll('[data-lp-hj-tile]');
    var submitBtn = root.querySelector('[data-lp-hj-submit]');
    var submitLabel = root.querySelector('[data-lp-hj-submit-label]');

    function getAllowedQtys(sizeKey) {
      var map = config.qtyBySize || {};
      return map[sizeKey] || [];
    }

    function getChews(sizeKey) {
      var map = config.chewsPerSize || {};
      return map[sizeKey] || 1;
    }

    function getSupply(sizeKey, quantity) {
      return (config.supplies || []).find(function (item) {
        return item.sizeKey === sizeKey && item.qty === quantity;
      });
    }

    function getButtonLabel(available) {
      return available ? (config.addToCartLabel || 'Add to Cart') : (config.soldOutLabel || 'Sold out');
    }

    function calcSavePercent(price, compare) {
      if (!compare || compare <= price) {
        return '';
      }
      return Math.round((1 - price / compare) * 100) + '%';
    }

    function renderBuy() {
      var allowed = getAllowedQtys(size);
      if (allowed.indexOf(qty) === -1) {
        qty = allowed[0] || null;
      }

      sizeBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-lp-hj-size');
        btn.classList.toggle('is-active', key === size);
      });

      ptypeBtns.forEach(function (btn) {
        var key = btn.getAttribute('data-lp-hj-ptype');
        btn.classList.toggle('is-active', key === pType);
      });

      tiles.forEach(function (tile) {
        var tileQty = parseInt(tile.getAttribute('data-qty'), 10);
        var tileSize = tile.getAttribute('data-size');
        var allowedForSize = getAllowedQtys(tileSize).indexOf(tileQty) !== -1;
        var visible = tileSize === size && allowedForSize;
        tile.hidden = !visible;
        if (!visible) {
          return;
        }

        var supply = getSupply(tileSize, tileQty);
        var isSub = pType === 'sub';
        var priceCents = supply ? (isSub ? supply.subPrice : supply.oncePrice) : 0;
        var compareCents = supply ? supply.comparePrice : 0;
        var saveTxt = calcSavePercent(priceCents, compareCents);
        var days = tileQty * 60 / getChews(tileSize);
        var perDay = days > 0 ? priceCents / days : 0;
        var isActive = tileQty === qty;

        tile.classList.toggle('is-active', isActive);

        var priceEl = tile.querySelector('[data-price]');
        var strikeEl = tile.querySelector('[data-strike]');
        var saveEl = tile.querySelector('[data-save]');
        var sublineEl = tile.querySelector('[data-subline]');
        var daysEl = tile.querySelector('[data-days]');
        var benSub = tile.querySelector('[data-ben-sub]');
        var benOnce = tile.querySelector('[data-ben-once]');
        var bestEl = tile.querySelector('[data-bestvalue]');

        if (priceEl) {
          priceEl.textContent = formatMoney(priceCents, symbol);
        }
        if (strikeEl) {
          if (saveTxt) {
            strikeEl.textContent = formatMoney(compareCents, symbol);
            strikeEl.hidden = false;
          } else {
            strikeEl.hidden = true;
          }
        }
        if (saveEl) {
          if (saveTxt) {
            saveEl.textContent = (config.savePrefix || 'SAVE ') + ' ' +saveTxt;
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
        if (sublineEl) {
          sublineEl.textContent = Math.round(days) + ' day supply · ' + formatMoney(perDay, symbol) + ' per day';
        }
        if (daysEl) {
          daysEl.textContent = Math.round(days);
        }
        if (benSub) {
          benSub.style.display = isSub ? 'flex' : 'none';
        }
        if (benOnce) {
          benOnce.style.display = isSub ? 'none' : 'flex';
        }
        if (bestEl) {
          var topQty = allowed[allowed.length - 1];
          bestEl.hidden = tileQty !== topQty;
        }
      });

      var selected = getSupply(size, qty);
      if (submitBtn) {
        submitBtn.disabled = !selected || !selected.available;
      }
      if (submitLabel && selected) {
        var label = getButtonLabel(selected.available);
        var price = pType === 'sub' ? selected.subPrice : selected.oncePrice;
        submitLabel.textContent = label + ' · ' + formatMoney(price, symbol);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-lp-hj-tab');
        tabs.forEach(function (item) {
          item.classList.toggle('is-active', item === tab);
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-lp-hj-panel') !== key;
        });
      });
    });

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        size = btn.getAttribute('data-lp-hj-size');
        qty = getAllowedQtys(size)[0] || null;
        renderBuy();
      });
    });

    ptypeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pType = btn.getAttribute('data-lp-hj-ptype');
        renderBuy();
      });
    });

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        qty = parseInt(tile.getAttribute('data-qty'), 10);
        renderBuy();
      });
    });

    root.querySelectorAll('[data-lp-hj-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-lp-hj-faq-row]');
        var answer = row && row.querySelector('[data-lp-hj-faq-answer]');
        if (!answer) {
          return;
        }
        var open = row.classList.contains('is-open');
        row.classList.toggle('is-open', !open);
        answer.hidden = open;
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', async function () {
        var selected = getSupply(size, qty);
        if (!selected || !selected.available || !selected.variantId) {
          return;
        }

        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');

        try {
          var formData = new FormData();
          formData.append('id', selected.variantId);
          formData.append('quantity', '1');
          if (pType === 'sub' && selected.sellingPlanId) {
            formData.append('selling_plan', selected.sellingPlanId);
          }

          var response = await fetch((window.themeVariables && window.themeVariables.routes.cartAddUrl || '/cart/add') + '.js', {
            method: 'POST',
            body: formData,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (response.ok) {
            if (config.redirectToCheckout) {
              window.location.href = config.checkoutUrl || '/checkout';
              return;
            } else{
              window.location.href = '/cart';
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        } catch (error) {
          console.error('[lp-hj-buybox] Add to cart failed', error);
        } finally {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          renderBuy();
        }
      });
    }

    renderBuy();
  }

  function bootHipJointBuybox(root) {
    initHipJointBuybox(root);

    var mediaWrap = root.querySelector('[data-lp-hj-media]');
    var sectionId = root.getAttribute('data-lp-hj-buybox') || '';
    if (!mediaWrap || !mediaWrap.querySelector('.lp-hj-buybox__gallery-main' + sectionId)) {
      return;
    }

    ensureSwiper(root, function () {
      initMediaGallery(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-lp-hj-buybox]').forEach(bootHipJointBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-hj-buybox]');
    if (!root) {
      return;
    }

    root.dataset.hjBuyboxReady = 'false';

    var sectionId = root.getAttribute('data-lp-hj-buybox') || '';
    var mainEl = root.querySelector('.lp-hj-buybox__gallery-main' + sectionId);
    if (mainEl) {
      mainEl.dataset.hjGalleryReady = 'false';
    }

    bootHipJointBuybox(root);
  });
})();
